import { MutationHookOptions, useMutation } from '@apollo/client';
import { graphql } from '../gql';
import {
  UpsertPolicyMutation,
  UpsertPolicyMutationVariables,
} from '../gql/graphql';
import { GET_POLICY_PAGE } from './policy-page.query';

export const UPSERT_POLICY = graphql(`
  mutation upsertPolicy($details: PolicyInput!) {
    upsertPolicy(details: $details) {
      uuid
      referenceId
    }
  }
`);

export function useUpsertPolicyMutation(
  options: MutationHookOptions<
    UpsertPolicyMutation,
    UpsertPolicyMutationVariables
  > = {}
) {
  const [upsertPolicy, { loading, error, reset }] = useMutation(UPSERT_POLICY, {
    refetchQueries: [GET_POLICY_PAGE],
    awaitRefetchQueries: true,
    ...options,
  });

  return {
    upsertPolicy,
    loading,
    error,
    reset,
  };
}
